import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useTracker } from '../tracking/useTracker';
import { StyledGoogleIdentityServicesLoading, StyledGoogleIdentityServicesLoadingContainer, StyledGoogleOAuthButton } from './GoogleOAuthButton.styles.ts';
import { useGoogleIdentityServices } from './useGoogleIdentityServices';
import { useGoogleLoginNonce } from './useGoogleLoginNonce';
import { useLoadGoogleIdentityServices } from './useLoadGoogleIdentityServices';
export const GoogleOAuthButton = () => {
  const googleButtonRef = useRef(null);
  const googleSignInNonce = useGoogleLoginNonce();
  const Tracker = useTracker();

  const onAuthenticationFailed = failure => Tracker.signupInteraction(`google-oauth-exception-${failure.reason}`);

  const {
    isLoading,
    isLoaded
  } = useLoadGoogleIdentityServices({
    onAuthenticationFailed
  });
  const isGoogleLibraryLoaded = !isLoading || isLoaded;
  useGoogleIdentityServices({
    googleButtonRef,
    libraryHasLoaded: isGoogleLibraryLoaded,
    googleSignInNonce
  });
  return /*#__PURE__*/_jsx(StyledGoogleOAuthButton, {
    className: "GoogleIdentityServicesButton",
    id: "g_id_onload",
    ref: googleButtonRef,
    children: isGoogleLibraryLoaded && /*#__PURE__*/_jsx(StyledGoogleIdentityServicesLoadingContainer, {
      children: /*#__PURE__*/_jsx(StyledGoogleIdentityServicesLoading, {
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          grow: true,
          layout: "centered",
          size: "extra-small"
        })
      })
    })
  });
};